import React from "react";
import { Box } from "@mui/joy";
import DarkTypography from "./DarkTypography";
import { AppConfigContext } from "../../contexts/app/appConfig";
import { zekayStaticBranding } from "../../config/staticFiles";

interface FooterBrandProps {
  showChromeNote?: boolean;
}

export default function FooterBrand({ showChromeNote }: FooterBrandProps) {
  const appConfig = React.useContext(AppConfigContext);
  const year = new Date().getFullYear();
  const chromeLogo = zekayStaticBranding.chromeBlackWebp();
  const karapazLogo = zekayStaticBranding.karapazWebp();

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 16,
        left: 0,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 0.5,
        pointerEvents: "none",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, pointerEvents: "auto" }}>
        <DarkTypography colorVariant="muted" sx={{ fontSize: 12 }}>
          by
        </DarkTypography>
        <img
          src={karapazLogo}
          alt="Karapaz"
          height={42}
          style={{ opacity: 1, filter: "invert(1) grayscale(1) brightness(1.08) contrast(1.05)" }}
        />
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, pointerEvents: "auto" }}>
        {showChromeNote && (
          <>
            <DarkTypography colorVariant="muted" sx={{ fontSize: 11, fontStyle: "italic" }}>
              Optimisé pour Chrome
            </DarkTypography>
            <img
              src={chromeLogo}
              width="20"
              alt="Chrome"
              style={{ filter: "invert(1)", opacity: 0.85 }}
            />
          </>
        )}
        {showChromeNote && (appConfig?.version || year) && (
          <DarkTypography colorVariant="muted" sx={{ fontSize: 11, opacity: 0.7 }}>
            •
          </DarkTypography>
        )}
        {appConfig?.version && (
          <DarkTypography colorVariant="muted" sx={{ fontSize: 11 }}>
            {appConfig.version}
          </DarkTypography>
        )}
        {appConfig?.version && (
          <DarkTypography colorVariant="muted" sx={{ fontSize: 11, opacity: 0.7 }}>
            •
          </DarkTypography>
        )}
        <DarkTypography colorVariant="muted" sx={{ fontSize: 11 }}>
          {year}
        </DarkTypography>
      </Box>
    </Box>
  );
}
